import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { URL_PATHS_MAP } from '../../app.routes';
import { MatIconModule } from '@angular/material/icon';
import { OtpVerificationService } from '../../core/services/otp-verification/otp-verification.service';
import { HttpStatusCode } from 'axios';
import { SnackbarService } from '../../shared/services/snackbar/snackbar.service';
import { SessionStorageService } from '../../core/services/session-storage/session-storage.service';
import { CurrentUserInfo } from '../../core/interfaces/current-user-info.interface';

@Component({
  selector: 'app-otp-verification',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    RouterModule,
    MatIconModule
  ],
  templateUrl: './otp-verification.page.html',
  styleUrl: './otp-verification.page.scss'
})
export class OtpVerificationPage implements OnInit {

  private formBuilder = inject(FormBuilder);
  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);
  private otpVerificationService = inject(OtpVerificationService);
  private snackBarService = inject(SnackbarService);

  otpVerifyFg!: FormGroup;

  protected returnTo!: string | null;

  protected isVerifyOtpLoading = signal(false);

  constructor() { }

  ngOnInit(): void {

    const URL_TOKEN = history.state.returnPath.toString();

    this.returnTo = URL_PATHS_MAP[URL_TOKEN] ?? '/';

    if (!this.returnTo) {
      console.error('Return URL is not provided.');
    }

    this.otpVerifyFg = this.formBuilder.group({
      otpCode: ["", [Validators.required]]
    });
  }

  protected async requestOtpEmail() {
    const responseData = await this.otpVerificationService
      .resendOtp()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
        const currentUserInfo: CurrentUserInfo = {
          email: this.sessionStorageService.getCurrentUserEmail(),
          accessToken: responseData.data.accesstoken,
          password: this.sessionStorageService.getCurrentUserPassword()
        };

        this.sessionStorageService.setCurrentUserInfo(currentUserInfo);
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
    }
  }

  protected async otpVerification() {
    const otpCode: string = this.otpVerifyFg.get('otpCode')?.value.toString();

    this.isVerifyOtpLoading.set(true);

    const responseData = await this.otpVerificationService
      .otpVerification(otpCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.isVerifyOtpLoading.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      const currentUserInfo: CurrentUserInfo = {
        repCode: responseData.data.responsedata.piasRepCode,
        email: responseData.data.responsedata.email,
        authToken: responseData.data.token,
        personName: responseData.data.responsedata.personName,
        userRole: responseData.data.responsedata.userRole,
        accessToken: responseData.data.accesstoken,
        userGroup: responseData.data.responsedata.usergroup
      };

      this.sessionStorageService.setCurrentUserInfo(currentUserInfo);
      this.router.navigate([this.returnTo]);
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("Invalid OTP");
      }
    }
  }

}
